export const getBeforeFieldContent = (introductionText?: string) => {
  return {
    beforeFieldContent: introductionText
  };
};
